module.exports = __webpack_public_path__ + "media/icons/cena@2x-35b9d27b.png";